module.exports = __webpack_public_path__ + "img/cancel.6a0691a6.png";